import { render } from "./CourseInfo.vue?vue&type=template&id=82dd2e6a&scoped=true"
import script from "./CourseInfo.vue?vue&type=script&lang=js"
export * from "./CourseInfo.vue?vue&type=script&lang=js"

import "./CourseInfo.vue?vue&type=style&index=0&id=82dd2e6a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-82dd2e6a"

export default script